export const ADMIN_PAGE_CONTENT_CLASSNAME = 'p-6'
